<template>
  <div>
    <div class="option-kline-header">
      <van-row>
        <van-col :span="9">
          <div v-if="datafeed && datafeed.open != 0" class="amount">
            <p
              class="van-ellipsis"
              :class="
                parseFloat(close) > parseFloat(open) ? 'data-up' : 'data-down'
              "
            >
              {{ parseFloat(close).toFixed(6) }}
            </p>
            <span
              :class="
                parseFloat(close) > parseFloat(open) ? 'data-up' : 'data-down'
              "
            >
              {{ parseFloat(close) > parseFloat(open) ? "+" : "" }}
              {{
                (
                  (parseFloat(close) - parseFloat(open)) /
                  parseFloat(open)
                ).toFixed(2)
              }}
              %</span
            >
          </div>
        </van-col>
        <van-col :span="5">
          <ul class="data-gray">
            <li>{{ $t("option.high") }}</li>
            <li>{{ $t("option.low") }}</li>
            <li>{{ $t("option.nums") }}</li>
          </ul>
        </van-col>
        <van-col :span="10" class="txt-right">
          <ul>
            <li>{{ parseFloat(high).toFixed(2) }}</li>
            <li>{{ parseFloat(low).toFixed(2) }}</li>
            <li>{{ parseFloat(vol).toFixed(8) }}</li>
          </ul>
        </van-col>
      </van-row>
    </div>
    <div class="chart-wrapper" style="position: relative">
      <div id="tv_chart" ref="tv_chart" style="width: 100%; height: 100%" />
      <van-loading
        v-if="loading"
        style="position: absolute; left: calc((100vw - 24px) / 2); top: calc((100% / 2)"
      />
    </div>
  </div>
</template>
  
<script>
import { TokenLangKey, TokenColorKey, getTokenbyName } from "@/utils/cookies";
import pako from "pako";
// eslint-disable-next-line no-unused-vars
class UDFDataFeed {
  constructor(wsUrl, thispage) {
    this._that = thispage;
    this._ws = new WebSocket(wsUrl);
    this._subscribers = new Map();
    this._initializeWebSocket();
  }

  _initializeWebSocket() {
    const thatws = this;
    this._ws.onmessage = (event) => {
      const data = event.data;
      const that = this;
      let reader = new FileReader();
      reader.onload = function (e) {
        let ploydata = new Uint8Array(e.target.result);
        let msg = pako.inflate(ploydata, { to: "string" });
        if (msg.indexOf("ping") != -1) {
          thatws._ws.send("pong");
        } else {
          that._handleRealtimeData(JSON.parse(msg));
        }
      };
      reader.readAsArrayBuffer(data, "utf-8");
    };

    this._ws.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };

    this._ws.onclose = () => {
      setTimeout(() => this._reconnect(), 3000);
    };
  }

  _reconnect() {
    console.log("尝试重新连接WebSocket...");
    this._ws = new WebSocket(this._ws.url);
    this._initializeWebSocket();
  }

  _handleRealtimeData(tick) {
    const symbolKey = `${tick.symbol}_${tick.resolution}`;
    const callback = this._subscribers.get(symbolKey);
    if (callback && tick.tick) {
      const bar = {
        time: tick.tick.id * 1000,
        open: tick.tick.open,
        high: tick.tick.high,
        low: tick.tick.low,
        close: tick.tick.close,
        volume: tick.tick.vol,
      };
      callback(bar);
    }
  }

  _normalizeInterval(resolution) {
    console.log("resolution:" + resolution);
    resolution = resolution.replace("1D", "D");
    resolution = resolution.replace("1W", "W");
    resolution = resolution.replace("1M", "M");
    const map = {
      1: "1min",
      5: "5min",
      15: "15min",
      30: "30min",
      60: "60min",
      4: "4hour",
      D: "1day",
      W: '1week',
      M: '1mon'
    };
    return map[resolution] || resolution;
  }

  subscribeBars(symbolInfo, resolution, onTick) {
    const symbolKey = `${symbolInfo.name}_${resolution}`;
    this._subscribers.set(symbolKey, onTick);
    const period = this._normalizeInterval(resolution);
    // 发送订阅请求到WebSocket
    this._ws.send(
      JSON.stringify({
        sub: "market." + symbolInfo.name + ".kline." + period,
      })
    );
  }

  unsubscribeBars(symbolKey) {
    this._subscribers.delete(symbolKey);
    this._ws.send(
      JSON.stringify({
        action: "unsubscribe",
        symbol: symbolKey.split("_"),
        interval: symbolKey.split("_"),
      })
    );
  }

  // 实现UDF协议必要方法
  onReady(callback) {
    callback({
      supports_search: true,
      supports_group_request: false,
      supported_resolutions: [
        "1",
        "5",
        "15",
        "30",
        "60",
        "4H",
        "D",
        "M",
        "W",
      ],
      intraday_multipliers: ["1", "5", "60"],
      supports_marks: false,
      supports_time: true,
      has_weekly_and_monthly: true,
    });
  }

  resolveSymbol(symbolName, onResolved) {
    onResolved({
      name: symbolName,
      ticker: symbolName,
      description: symbolName,
      type: "crypto",
      session: "24x7",
      timezone: "UTC",
      pricescale: 100,
      minmov: 1,
      has_intraday: true,
      has_no_volume: false,
      has_weekly_and_monthly: true,  // 启用周月线
    });
  }

  getBars(symbolInfo, resolution, from, to, onResult) {
    // 实现历史数据获取逻辑 199
    fetch(
      "/huobiapi/market/history/kline?period=" +
        this._normalizeInterval(resolution) +
        "&size=200&symbol=" +
        symbolInfo.name
    )
      .then((res) => res.json())
      .then((data) => {
        this._that.loading = false;
        let bars = data.data.map((item) => ({
          time: item.id * 1000,
          tiemshow: new Date(item.id * 1000),
          open: item.open,
          high: item.high,
          low: item.low,
          close: item.close,
          volume: item.vol,
        }));
        bars = this.arrSort(bars, "time");
        onResult(bars, { noData: !bars.length });
      })
      .catch((error) => {
        console.log(error);
        this._that.loading = true;
      });
  }

  arrSort(arr, key) {
    return [...arr].sort((a, b) => a[key] - b[key]);
  }
}

export default {
  name: "TradingItem",
  props: {
    symbol: {
      type: String,
      default: "btcusdt",
    },
    interval: {
      type: String,
      default: "1D",
    },
  },
  data() {
    return {
      loading: false,
      datafeed: null,
      widget: null,
      timer: null,
      low: 0,
      high: 0,
      open: 0,
      close: 0,
      vol: 0,
      amount: 0,
    };
  },
  mounted() {
    const that = this;
    this.getDayData();
    this.$nextTick(() => {
      that.timer = setInterval(() => {
        that.getDayData();
      }, 5000);
    });

    this.initTradingView();
  },
  methods: {
    initTradingView() {
      const that = this;
      // 初始化数据源
      this.datafeed = new UDFDataFeed("wss://api-aws.huobi.pro/ws", that);
      // 加载TradingView脚本
      const script = document.createElement("script");
      script.src = "/charting_library/charting_library.min.js";
      script.onload = () => {
        this.createWidget();
      };
      document.head.appendChild(script);
    },
    createWidget() {
      //中国语（台湾）zh_TW中国语zh荷兰语（荷兰）nl_NL英语en法语fr德语 (德国)de_DE希腊语el意大利语it日语ja韩语ko波斯语(伊朗)fa_IR葡萄牙语pt俄语ru西班牙语es泰语(泰国)th_TH土耳其语tr越南语vi
      const containerWidth = window.innerWidth;
      const containerHeight = window.innerHeight - 240; //46 94 55 50
      const theme = getTokenbyName(TokenColorKey) == "night" ? "Dark" : "Light";
      let locale = getTokenbyName(TokenLangKey);
      locale = "en";
      this.widget = new window.TradingView.widget({
        width: containerWidth,
        height: containerHeight,
        debug: false,
        container_id: "tv_chart", //k线div容器id
        symbol: this.symbol, //商品名称
        // interval: 5, //默认显示时间分辨率15分钟
        // fullscreen: true,
        locale: locale, //强制指定语言环境
        theme: theme, //主题 Dark Light
        // autosize: true,
        datafeed: this.datafeed, ////调用datafeed初始化函数
        library_path: "/charting_library/", //static文件夹的路径
        has_weekly_and_monthly: true,
        disabled_features: [
          // "use_localstorage_for_settings",
          "left_toolbar", //隐藏左边工具栏
          // "header_saveload",
          "header_symbol_search", //隐藏搜索框
          "header_interval_dialog_button", //隐藏设置周期按钮
          "timeframes_toolbar", //隐藏底部刻度栏
          // "header_chart_type", //隐藏k线样式选择
          "header_fullscreen_button", //全屏开关
          "header_undo_redo", //隐藏撤销重做按钮
          "header_compare", //隐藏比较/增加商品按钮
          "header_screenshot", //隐藏截屏按钮
          // "header_resolutions",
          "edit_buttons_in_legend",
          "pane_context_menu",
          "legend_context_menu",
          "adaptive_logo",
          "display_market_status",
          "volume_force_overlay",
          "study_templates",
          "header_settings",
        ],

        // 启用插件
        // enabled_features: ["drafting_toolbar",'header_widget_dom_node'],
        overrides: {
          //蜡烛样式
          "mainSeriesProperties.candleStyle.upColor": "#48b451",
          "mainSeriesProperties.candleStyle.downColor": "#db000c",
          // "paneProperties.background": "#131722",
          // "paneProperties.vertGridProperties.color": "#363c4e",
          // "paneProperties.horzGridProperties.color": "#363c4e",
        },
      });
      
      this.widget.onChartReady(() => {
        this.widget.subscribe("time_interval", function (data) {
          console.log("当前周期:", data.resolution);
        });
        const chart = this.widget.chart();
        chart.createStudy("Moving Average", false, false);
      });
    },
    getDayData() {
      fetch("/huobiapi/market/detail?symbol=" + this.symbol)
        .then((res) => res.json())
        .then((data) => {
          if (data.status == "ok") {
            this.low = data.tick.low;
            this.high = data.tick.high;
            this.open = data.tick.open;
            this.close = data.tick.close;
            this.vol = data.tick.vol;
            this.amount = data.tick.amount;
          }
        });
    },
  },
  watch: {
    symbol(newVal) {
      if (this.widget) {
        console.log(this.widget);
        this.widget.chart().setSymbol(newVal, () => {
          console.log("Symbol changed to:", newVal);
        });
      }
    },
    interval(newVal) {
      if (this.widget) {
        this.widget.chart().setResolution(newVal);
      }
    },
  },
  beforeDestroy() {
    // 销毁实例
    if (this.timer) clearInterval(this.timer);

    if (this.widget) {
      this.widget.remove();
      this.widget = null;
    }
  },
};
</script>
  
  <style scoped>
.chart-wrapper {
  width: 100vw;
  min-height: 200px; /* 最小高度限制 */
  position: relative;
}
</style>
  